module.exports = __webpack_public_path__ + "img/clear-night.8e586e38.svg";